export enum ECompanyLevels {
  COMPANY = "COMPANY",
  INSPECTOR = "INSPECTOR",
  OPERATOR = "OPERATOR",
}

export enum LEVELS {
  REPUBLIC = "REPUBLIC",
  REGION = "REGION",
  DISTRICT = "DISTRICT",
  COMPANY = "COMPANY",
  INSPECTOR = "INSPECTOR",
  OPERATOR = "OPERATOR",
  RESIDENT = "RESIDENT",
}
